import { SectionListSkillItem } from './SectionListSkillItem';

export const SectionListSkill = ({
  skills,
}: {
  skills: {
    title: string;
  }[];
}) => {
  return (
    <section className="mb-12">
      <h2 className="text-2xl font-bold mb-4">Features</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {skills?.map((skill) => (
          <SectionListSkillItem key={skill.title} title={skill.title} />
        ))}
      </div>
    </section>
  );
};
